export enum pageTypes {
  PRODUCT = 'Product Detail Page',
  SEARCH_SUGGESTIONS = 'Search Suggestions Page',
  HOME = 'Nykaa : Home Page',
  CATEGORY = 'Category Page',
  SEARCH_LISTING = 'Search Page',
  SEARCH_REDIRECTION = 'Msite:searchRedirectionPage',
  PRO_INTRO = 'Pro Intro',
  ALL_REVIEW = 'Msite:AllReview',
  SIZE_CHART = 'Msite:sizeChart',
  CMS_PAGE = 'CMS Page',
  REVIEW_PAGE = 'reviewPage',
}

export enum pageNamePrefix {
  PRODUCT = 'Nykaa : product page: ',
  ALL_REVIEW_IMAGE_GRID = 'Nykaa:AllReviewPage:ImageGrid',
  HOME = 'Nykaa : Home Page',
  CATEGORY = 'Nykaa',
  OFFER_PAGE = 'offer page',
  ALL_REVIEW = 'Msite:AllReview',
  SEARCH_QUERY = 'Nykaa:searchquery',
}

export enum listingPageTypes {
  CATEGORY = 'category',
  OFFER_LISTING = 'Offer Listing',
  BRAND = 'brand',
}

// ? Picked up these from nykaa_fe
export const events = {
  ADD_TO_CART_CLICK: 'addToCartClick',
  ADD_TO_CART_SUCCESS: 'addToCartSuccess',
  ADD_TO_WISHLIST_SUCCESS: 'addToWishlistSuccess',
  PRODUCT_PAGE_VIEW_CLIENT: 'productPageViewClient',
  USER_DATA_FETCH: 'userDataFetched',
  USER_LOGOUT: 'userLoggedout',
  NOTIFY_ME: 'notifyMe',
  NOTIFY_ME_SUBMIT: 'notifyMeSubmit',
  GAMOOGA_CART_SUCCESS: 'gamoogaCartSuccess',
  VARIANT_CHANGE_ON_PD: 'variantChangePD',
  RATE_PRODUCT_CLICK: 'rateProductClick',
  REMOVE_ROM_WISHLIST: 'removeFromWishlist',
  REVIEW_IMAGE_CLICK: 'reviewImageClick',
  REVIEW_FILTER_SELECTED: 'filterSelected',
  REVIEW_SORT_SELECTED: 'sortSelected',
  IMAGE_GRID_PAGE: 'imageGridPage',
  VIEW_SIMILAR_CLICK: 'viewSimilarClick',
  OFFERS_TAG_CLICK: 'offersTagClick',
  ALL_SHADES_CLICK: 'allShadesClick',
  REVIEW_IMAGE_CLOSE: 'reviewImageClose',
  ALL_REVIEW_CLICK: 'allReviewsClick',
  COMBO_REVIEW_CLICK: 'comboReviewClicked',
  GUIDE_CLICK: 'guideClick',
  GUIDE_OPENED: 'guideOpened',
  PRODUCT_VIDEO_PLAY: 'productVideoPlay',
  SIZE_CHART_CLICK: 'sizeChartClick',
  VOICE_SEARCH_CLICK: 'voiceSearchClick',
  VOICE_SEARCH_TRY_AGAIN: 'voiceSearchTryAgain',
  CLICK_INTERACTION: 'clickInteractionNew',
  BANNER_EVENTS: 'bannerEvents',
  VERLOOP_LOAD: 'loadVerloop',
  VERLOOP_LOGOUT: 'logoutVerloop',
  CUSTOM_BANNER_CLICK: 'customBannerClick',
  CHECK_PIN_CODE: 'checkPinCode',
  READ_MORE_CLICK: 'READ_MORE_CLICK',
  CAROUSAL_SLIDE_CHANGE: 'carousalSlideChange',
  PDP_IMAGE_CLICK: 'imageInCarouselClick',
  PDP_IMAGE_ENLARGE_ICON_CLICK: 'imageEnlargeIconClick',
  CONFIG_EXPIRED: 'reactConfigExpired',
  PDP_CAROUSAL_SWIPES: 'PDP_CAROUSAL_SWIPES',
  PDP_VIDEO_SWIPED: 'PDP_VIDEO_SWIPED',
};

export enum PageRootTypes {
  SEARCH = 'search',
  CAV_PD = 'cav_pd',
  CAB_PD = 'cab_pd',
  MFC_PD = 'mfc_pd',
  MFB_PD = 'mfb_pd',
  SIMILAR_PRODUCTS_PD = 'similar_pd',
  SIMILAR_PRODUCTS_PD_HORIZONTAL = 'similar_pd_horizontal',
  SIMILAR_PRODUCTS_ON_IMAGE = 'similar_pd_on_image',
  NAV = 'nav_',
  OFFER_PDP = 'pdp',
  PRODUCT_COMPARISON = 'product_comparison',
  SEARCH_BOX = 'searchBox',
  RELATED_SEARCHES = 'related_searches',
  HLP_PD = 'hlp_pd',
  CAT_CAV_PD = 'category_cav',
  FULL_SCREEN_RECO_WIDGET = 'full_screen_reco_widget',
}

export enum SiteNavigation {
  SEARCH = 'search',
  PRODUCT = 'Product Page',
  CATEGORY = 'Category',
  HLP = 'pdpWidget',
  WIDGETS = 'pdpWidget',
  SEARCH_BOX = 'searchBox',
  WISHLIST = 'wishlist',
  PRODUCT_WIDGETS = 'productWidget',
  PDP = 'productDetailPage',
  HOME = 'homepage',
  HLP_WIDGET = 'hybridLP',
}

export const HAMBURGER = 'hamburger';
export const CATEGORY_TAB = 'categoryTab';
export const BRAND_TAB = 'brandTab';

export enum siteSubNavigationPrefix {
  SEARCH = 'search:',
  PRODUCT_CAV = 'pdpWidget:Customers Also Viewed:cav',
  PRODUCT_CAV_VERTICAL = 'pdpWidget:Customers Also Viewed:cav',
  PRODUCT_CAB = 'pdpWidget:Customers Also Bought:cab',
  PRODUCT_SIMILAR_PRODUCTS = 'pdpWidget:Similar Products:similarproducts',
  PRODUCT_MFC = 'pdpWidget:More from category:mfc',
  PRODUCT_SIMILAR_PRODUCTS_HORIZONTAL = 'pdpWidget:Similar Products:similarproducts',
  PRODUCT_SIMILAR_PRODUCTS_ON_IMAGE = 'pdpWidget:Explore Similar Products:horizontal_slider',
  PRODUCT_COMPARE_PRODUCTS = 'pdpWidget:ProductComparison:compare',
  PRODUCT_CATEGORY_CAV = 'pdpWidget:Category Customer Also Viewed:cav',
  SEARCH_BOX_RECENTLY_VIEWED = 'SearchBox:RECENTLY VIEWED PRODUCTS',
  RELATED_SEARCHES = 'relatedSearchWidget',
  CATEGORY = 'Category : ', // TODO: MSR-1499 - siteSubNavigationLogic
  HLP = 'pdpWidget:hybridLP',
  WISHLIST = 'Wishlist:',
  HLP_SUB_NAV = 'hybridLP',
  PDP_BRAND = `productDetailPage:${HAMBURGER}:${BRAND_TAB}`,
  PDP_CATEGORY = `productDetailPage:${HAMBURGER}:${CATEGORY_TAB}`,
  HOME_BRAND = `homepage:${HAMBURGER}:${BRAND_TAB}`,
  HOME_CATEGORY = `homepage:${HAMBURGER}:${CATEGORY_TAB}`,
  FULL_SCREEN_RECO_WIDGET = 'pdpWidget:Similar Products:Horizontal Slider',
  RECO_WIDGET = 'recoWidget',
}
export const FEATURED = 'Featured';
export const NOT_FEATURED = 'NotFeatured';

export const SHARE_PRODUCT = 'shareProduct';
export const SHARE_CONTINE_CLICKED = 'share_continue_click';
export const PDP_COMBO_WIDGET = 'pdpComboWidget';
export const EXPLORE_SIMILAR_CATEGORY_LOADS =
  'explore_similar_category_widget_loads';
export const EXPLORE_CATEGORY_PDP_LOCATION = 'relevantCategory';
export const AUTO_SUGGESTION_ARROW_CLICKED = 'arrowClicked';

export const defaultDataLayer = () => ({
  isMobile: true,
  gaId: process.env.GA_ID,
  optimizeId: process.env.OPTIMIZE_ID,
  newStack: true,
});

export enum PageSource {
  SEARCH = 'Search',
  NO_SEARCH_RESULT = 'NoSearchResult',
  BANNER = 'Banner',
  MEGA_MENU = 'MM',
  WIDGETS = 'Widget',
  OTHERS = 'Others',
  CAB_WIDGET = 'widget: customeralsobought',
  CAV_WIDGET = 'widget: customeralsoviewed',
  Product = 'product',
  CATEGORY = 'Listing',
  QUERY = 'query',
  OFFER_PAGE = 'mweb:offer page',
  COMBO_PRODUCT = 'comboWidget',
  SIZE_CHART = 'size-chart',
  ALL_SHADE = 'all_shade',
  VIDEO_FULL_SCREEN = 'VideoFullScreen',
  IMAGE_FULL_SCREEN = 'ImageFullScreen',
  SEARCH_BOX = 'SearchBox',
  RELATED_WIDGETS = 'relatedSearchWidget',
  HOME = 'Home',
  BEST_SELLER = 'bestSellerListingPage',
  TOP_CARD = 'topCard',
  SHADE_PAGE = 'shadePage',
  SIZE_PAGE = 'sizePage',
}

export const PLP_SUB_NAV_SUFFIX = 'mega-menu';
export const IN_STOCK = 'instock';
export const OUT_OF_STOCK = 'outofstock';
export const SEARCH_QUERY = 'query';

export const cartViewLocation = {
  SIZE_CHART: 'productDetailPage:sizeChart:Bag',
  SIZE_CHART_VIEW_BAG: 'productDetailPage:sizeChart:ViewBag',
  ALL_SHADE: 'productDetailPage:ViewShade:ViewBag',
  PRODUCT_PAGE: 'productDetailPage:ViewBag',
  HOME_PAGE: 'homePage:CartIcon',
  PLP_TOP_NAV: 'productListingPage:CartIcon',
  PLP_VIEW_BAG: 'productListingPage:ViewBag',
  SLP_TOP_NAV: 'searchListingPag:CartIcon',
  SLP_VIEW_BAG: 'searchListingPage:ViewBag',
  ACCOUNTS_PAGE: 'accountsPage:CartIcon',
  WISHLIST_PAGE_TOP_NAV: 'wishlistPage:CartIcon',
  WISHLIST_VIEW_BAG: 'wishlistPage:ViewBag',
  PDP_TOP_NAV: 'productDetailPage:CartIcon',
  PDP_VIEW_BAG: 'productDetailPage:ViewBag',
  NLP_TOP_NAV: 'nativeLandingPage:CartIcon',
  NLP_VIEW_BAG: 'nativeLandingPage:ViewBag',
  HLP_TOP_NAV: 'hybridLandingPage:CartIcon',
  HLP_VIEW_BAG: 'hybridLandingPage:ViewBag',
  OTHER_PAGE: 'otherPage',
};

export const pdpActionSource = {
  WIDGET_SHADE: 'nykaa:pdp:widget:shade',
  WIDGET: 'nykaa:pdp:widget',
};

export const reviewActionSource = {
  PDP: 'nykaa:pdp',
  ALL_REVIEW: 'nykaa:pdp:AllReviews',
};
export const recommendationsAction = {
  VIEW_ALL: 'recommendViewAll',
};
export const popularWidgets = {
  POPULAR_BRANDS: 'Popular Brands',
  POPULAR_CATEGORIES: 'Popular Categories',
};

export const SOURCE_SUB_SITE_NAVIGATION = {
  HLP_RECO: `${SiteNavigation.HLP_WIDGET}:${siteSubNavigationPrefix.RECO_WIDGET}`,
  PDP_RECO: `${SiteNavigation.PDP}:${siteSubNavigationPrefix.RECO_WIDGET}`,
  HLP_RECO_SIMILAR_PRODUCT: `${SiteNavigation.HLP_WIDGET}:${siteSubNavigationPrefix.RECO_WIDGET}:Explore Similar Products`,
  PDP_RECO_SIMILAR_PRODUCT: `${SiteNavigation.PDP}:${siteSubNavigationPrefix.RECO_WIDGET}:Explore Similar Products`,
  HLP_RECO_CUSTOMER_ALSO_VIEWED: `${SiteNavigation.HLP_WIDGET}:${siteSubNavigationPrefix.RECO_WIDGET}:Customers Also Viewed`,
  PDP_FULL_SCREEN: `${SiteNavigation.PDP}:imageFullscreen`,
  HLP_TOP_CARD: `${SiteNavigation.HLP_WIDGET}:topCard`,
  PDP_RECO_CAB: `${SiteNavigation.PDP}:${siteSubNavigationPrefix.RECO_WIDGET}:Customers Also Bought`,
  HLP_RECO_CAB: `${SiteNavigation.HLP_WIDGET}:${siteSubNavigationPrefix.RECO_WIDGET}:Customers Also Bought`,
  PDP_RECO_SIMILAR: `${SiteNavigation.PDP}:${siteSubNavigationPrefix.RECO_WIDGET}:Similar Products`,
  HLP_RECO_SIMILAR: `${SiteNavigation.HLP_WIDGET}:${siteSubNavigationPrefix.RECO_WIDGET}:Similar Products`,
  PDP_SIZE: `${SiteNavigation.PDP}:sizePage`,
  PDP_SHADE: `${SiteNavigation.PDP}:shadePage`,
  HLP_TOP_CARD_SIZE: `${SiteNavigation.HLP_WIDGET}:topCard:sizePage`,
  HLP_TOP_CARD_SHADE: `${SiteNavigation.HLP_WIDGET}:topCard:shadePage`,
  CAV_TITLE: 'Customers Also Viewed',
  BOTTOMSHEET_SIMILAR_PRODUCTS: `${SiteNavigation.PDP}:viewSimilarBottomSheet`,
  PDP_RECO_RECENTLY_VIEWED: `${SiteNavigation.PDP}:${siteSubNavigationPrefix.RECO_WIDGET}:Recently Viewed`,
  HLP_RECO_RECENTLY_VIEWED: `${SiteNavigation.HLP_WIDGET}:${siteSubNavigationPrefix.RECO_WIDGET}:Recently Viewed`,
};

export const cabJourneyData = {
  siteNavigation: SiteNavigation.WIDGETS,
  siteSubNavigation: siteSubNavigationPrefix.PRODUCT_CAB,
  sourceSubSiteNavigation: SOURCE_SUB_SITE_NAVIGATION.PDP_RECO,
};

export const plpInteractions = {
  PRODUCT_CARD_CLICK: 'productImageCard',
  ADD_TO_BAG: 'addToBag',
  ADD_TO_WISHLIST: 'addToWishlist',
  REMOVE_WISHLIST: 'removeFromWishlist',
  SELECT_SHADE: 'selectShade',
  NOTIFY_ME: 'notifyMe',
  TIP_TILE: 'tiptile',
};
export const RANK_BEST_SELLER_CLICK = 'rankBestsellerClick';

export const locationPathname = {
  HOME: '/',
  PLP: '/c/',
  PDP: '/p/',
  SLP: '/search/result',
  WISHLIST: '/wishlist',
  NLP: '/sp/',
  LP_PAGE: '/lp',
  HLP: '/hlp/',
  CP: '/cp/',
};

export const OFFER_PRODUCT_LISTING = 'OfferProductListing';
